import { SECOND } from "src/constants";
import { SessionWorkerMessageType } from "src/workers/refreshToken/enums";
import { WorkerMessage } from "src/workers/refreshToken/type";

let interval: ReturnType<typeof setInterval> | null;

self.onmessage = (
  e: MessageEvent<{
    expirationTsSec: number;
    lifeTimeCheckInterval: number;
    timeToRefreshBeforeExpiration: number;
  }>
) => {
  const {
    expirationTsSec,
    lifeTimeCheckInterval,
    timeToRefreshBeforeExpiration,
  } = e.data;

  if (!expirationTsSec) {
    return;
  }

  if (interval) {
    clearInterval(interval);
  }

  interval = setInterval(() => {
    const tokenLifeTimeMS = expirationTsSec * SECOND - Date.now();

    if (tokenLifeTimeMS < timeToRefreshBeforeExpiration) {
      const message: WorkerMessage = {
        type: SessionWorkerMessageType.REFRESH_TOKEN,
        payload: {
          shouldTokenUpdate: true,
        },
      };

      self.postMessage(message);

      if (interval) {
        clearInterval(interval);
        interval = null;
      }
    }
  }, lifeTimeCheckInterval);
};

export {};
